import { createContext } from 'react';

import { type PaginationID } from './pagination.types'

export const PaginationControlsContext = createContext<{
  id: PaginationID | undefined
}>({ id: undefined })
